import { Selector } from "react-redux";

import { IAppState } from "@multiweb/types/react";

/**
 * Získá z globálního stavu podstrom patřící fetching modulu.
 */
const getModel = (state: IAppState) => state.core.fetching;

/**
 * Zjistí, zda pro zadaný klíč probíhá načítání. Pokud daný klíč neexistuje, vrací false.
 *
 * @param state
 * @param key Klíč slouží k identifikaci načítaných dat. Musí se shodovat s klíčem zadaným do akce setFetching.
 */
export const isFetching: Selector<IAppState, boolean, string> = (state, key) => getModel(state)[key] === true;
